import {Component, inject} from '@angular/core'
import {MatButtonModule} from '@angular/material/button'
import {MatIconModule} from '@angular/material/icon'
import {MatMenuModule} from '@angular/material/menu'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {
  LogoComponent,
  ToggleButtonComponent
} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {ADMIN_MODULE} from '../../application/types'


@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatButtonModule, MatMenuModule, MatIconModule, LogoComponent, ToggleButtonComponent]
})
export class HeaderComponent {
  protected readonly canUseTestingTools = !environment.production
  protected readonly service = inject(ConfigService)
  protected readonly ADMIN_MODULE = ADMIN_MODULE
}
